import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import CustomReveal from '../../common/reveal/CustomReveal';
import CustomIcon from '../../common/CustomIcon';
import CustomButton from '../../common/CustomButton';
import * as bookActions from '../../../actions/bookActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import { isValidUrl } from '../../../services/domain/bookService';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class AddLessonLinkReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.handleAddLink = this.handleAddLink.bind(this);
    this.handleIsValidName = this.handleIsValidName.bind(this);
    this.handleIsValidLink = this.handleIsValidLink.bind(this);
  }

  static propTypes = {
    bookActions: PropTypes.any,
    idBook: PropTypes.string,
    idClassroom: PropTypes.string,
    selectedUnit: PropTypes.object,
    isLinkLessonModalOpen: PropTypes.bool,
    colors: PropTypes.object
  };

  cleanForm() {
    this.refs['lessonLink'].className = '';
    this.refs['lessonName'].className = '';
    this.refs['errorLessonName'].className = '';
    this.refs['errorLessonLink'].className = '';
  }

  resetForm() {
    this.refs['lessonLink'].value = '';
    this.refs['lessonName'].value = '';
    this.refs['errorLessonName'].className = '';
    this.refs['errorLessonLink'].className = '';
  }

  closeModal() {
    this.props.bookActions.setIsLinkLessonModalOpen(false);
    this.cleanForm();
    this.resetForm();
  }

  handleIsValidName() {
    let lessonName = this.refs['lessonName'].value;
    this.refs['lessonName'].className = !lessonName ? 'error' : '';
    this.refs['errorLessonName'].className = !lessonName ? 'error' : '';
    return lessonName;
  }

  handleIsValidLink() {
    let url = isValidUrl(this.refs['lessonLink'].value);
    this.refs['lessonLink'].className = !url ? 'error' : '';
    this.refs['errorLessonLink'].className = !url ? 'error' : '';
    return url;
  }

  handleAddLink() {
    const { idBook, idClassroom, selectedUnit } = this.props;
    this.cleanForm();
    let lessonName = this.refs['lessonName'].value;
    let url = this.refs['lessonLink'].value;
    if (this.handleIsValidName() && this.handleIsValidLink()) {
      const bookContext = {
        idClassroom,
        idBook,
        unitActivityId: selectedUnit.activityId
      };
      this.props.bookActions.addLinkLesson(lessonName, url, bookContext);
      this.closeModal();
    }
  }

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.handleAddLink();
    }
  };

  render() {
    const { isLinkLessonModalOpen, colors } = this.props;

    return (
      <Modal
        id="add_lesson_link"
        title={I18n.t('addLessonLink.newLink')}
        active={isLinkLessonModalOpen}
        onClickOutside={this.closeModal}
        children={
          <>
            <div className="lesson_link margin-bottom-20">
              <input
                id="add-lesson-link-title-input"
                type="text"
                className="margin-bottom-4"
                onBlur={this.handleIsValidName}
                ref="lessonName"
                placeholder={I18n.t('addLessonLink.urlPlaceHolderName')}
                onKeyPress={this.handleKeyPress}
              />
              <span id="error-lesson-name" ref="errorLessonName">
                {I18n.t('addLessonLink.invalidName')}
              </span>
            </div>

            <div className="lesson_link">
              <input
                id="add-lesson-link-link-input"
                type="text"
                className="margin-bottom-4"
                onBlur={this.handleIsValidLink}
                ref="lessonLink"
                placeholder={I18n.t('addLessonLink.urlPlaceholder')}
                onKeyPress={this.handleKeyPress}
              />
              <span id="error-lesson-link" ref="errorLessonLink">
                {I18n.t('addLessonLink.invalidUrl')}
              </span>
            </div>
          </>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button
              id="add-lesson-link-submit"
              onClick={this.handleAddLink}
              primary
              label={I18n.t('common.add')}
            ></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLinkLessonModalOpen: state.book.isLinkLessonModalOpen,
    i18n: state.i18n,
    selectedUnit: state.book.selectedUnit,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddLessonLinkReveal);
